import { render } from "./Dashboard-Component.vue?vue&type=template&id=f96778a4&scoped=true"
import script from "./Dashboard-Component.vue?vue&type=script&lang=js"
export * from "./Dashboard-Component.vue?vue&type=script&lang=js"

import "./Dashboard-Component.vue?vue&type=style&index=0&id=f96778a4&scoped=true&lang=css"
import "./Dashboard-Component.vue?vue&type=style&index=1&id=f96778a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96778a4"]])

export default __exports__